export default __webpack_public_path__ + "static/media/eth.75644cc9.png";